<template>
    <div>
        <div class="layui-tab layui-tab-brief">
            <ul class="layui-tab-title">
                <li :class="index == 0 ? 'layui-this' : ''" v-for="(item, index) in items" :key="index">{{ item.name }}</li>
            </ul>
            <div class="layui-tab-content x-round  x-mt24">
                <div class="layui-tab-item" :class="index == 0 ? 'layui-show' : ''" v-for="(item, index) in items"
                    :key="index">
                    <div v-for="(course, m) in item.courses" :key="m">
                        <ul class="layui-menu">
                            <li class="layui-menu-item-group"
                                :class="m == 0 ? 'layui-menu-item-down' : ' layui-menu-item-up'">
                                <div class="layui-menu-body-title type">
                                    {{ m + 1 }}. {{ course.name }}<i class="layui-icon layui-icon-up"></i>
                                </div>
                                <ul class="x-bg-grey x-round x-relative">
                                    <li class="desc-h">
                                        <div class="detail" v-for="(desc, n) in course.desc || []" :key="n">
                                            {{ desc }}
                                        </div>
                                    </li>
                                    <li class="price-box" v-if="course.old_price && course.new_price">
                                        <p>小鸥优惠价<span class="x-size-14 x-color-grey">（不与学校限时优惠叠加）</span></p>
                                        <p class="old x-color-grey">{{myUtils.getCurrentCurrency()}}{{ course.old_price }}/周</p>
                                        <p><span class="price">{{myUtils.getCurrentCurrency()}}{{ course.new_price }}/周</span></p>
                                        <p>
                                            <a :href="`/${myUtils.getCurrentCountry()}-signup?${myUtils.objectToQueryString({ id: oSchool.id, name: oSchool.attributes.name, course: course.name })}`"
                                                class="x-submit">
                                                免费报名
                                            </a>
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.desc-h {
    min-height: 150px;
}

.old {
    text-decoration-line: line-through;
}

@media screen and (min-width: 767.98px) {
    .price-box {
        position: absolute;
        right: 16px;
        top: 16px;
        text-align: right;
    }
}

.price {
    color: var(--functional-red-3, #EF454A);
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.layui-tab-content {
    border: 1px solid #F4F5F6;
}

.layui-tab-title li {
    font-size: 24px
}

.layui-tab-item {
    /* margin-top: 30px; */
}

.layui-menu .type {
    margin: 12px 0;
    color: var(--text-text-primary, #2B2F33);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.layui-menu .x-round {
    padding: 0 16px;
}

.detail-box {
    padding: 24px;
    margin: 16px 0;
}

.detail {
    color: var(--text-text-primary, #2B2F33);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 16px 0;
    white-space: normal;
}

.layui-menu {}

.layui-menu .layui-menu-item-checked:after {
    border-right: none;
}

.layui-tab-brief>.layui-tab-title .layui-this {
    color: #2B2F33;
}

.layui-tab-brief>.layui-tab-more li.layui-this:after,
.layui-tab-brief>.layui-tab-title .layui-this:after {
    border-bottom-color: #FFE117;
}
</style>


<script setup>

// const items = ref([
//     {
//         name: "一般英语",
//         courses: [
//             {
//                 name: "一般英语课程15(上午)",
//                 desc: [
//                     "课时：每周15堂课，每堂55分钟，总计13小时",
//                     "开课日期：每周一",
//                     "上课时间：星期一~星期五 9:00am~12pm",
//                     "每班平均人数：14 人"
//                 ]
//             }
//         ]
//     }
// ]);
const items = ref([]);
const props = defineProps({
    data: Object
})
const aItems = [];
const oSchool = props.data.data;
const oCourses = props.data.data.attributes.courses;
const discount_num = props.data.data.attributes.discount_num;
if (oCourses) {
    oCourses.forEach(element => {
        let aEle = [];
        element?.detail.forEach(ele => {
            let new_price;
            let weeks;
            let old_price;
            if (discount_num != 100) {
                let nPrice = myUtils.formatPrice(ele.price);
                if (nPrice.length > 0) {
                    nPrice.some((oPrice) => {
                        // if (oPrice.weeks < 4) {
                        //     return false;
                        // }
                        //人民币计价
                        // old_price = myUtils.fixPrice(oPrice.price * useRuntimeConfig().public.rate_Pounds);
                        // new_price = myUtils.fixPrice(oPrice.price * useRuntimeConfig().public.rate_Pounds * discount_num / 100);
                        //原始货币计价
                         old_price = myUtils.fixPrice(oPrice.price);
                         new_price = myUtils.fixPrice(oPrice.price * discount_num / 100);
                        weeks = oPrice.weeks;
                        return true;
                    });
                }
            }
            aEle.push({
                name: ele.name,
                desc: ele.detail?.split('\n'),
                new_price: new_price || "",
                old_price: old_price || "",
                weeks: weeks || ""
            })
        });
        aItems.push({
            name: element.name,
            courses: aEle
        })
    });
}
items.value = aItems;
</script>